import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Radio,
    Button,
    CardContent,
    withStyles,
    Divider
} from "@material-ui/core";
import { useMobileStyles } from "./styles.js";
import { PAGES } from "../../../utils/constant";
import {getPermissionDeniedToastMessage} from "../../../utils/utility";
import { Header } from "../../../components";
import Cards from "../../../components/Cards/index.js";
import Icon from "../../../utils/icons.js";
import ToastMessage from "../../../components/ToastMessage/index.js";
import {RangeSlider} from "../../../components/RangeSlider";
import HCServices from "../../../services/hcServices.js";


const HvacEnergyMode = (props) => {
    const classes = useMobileStyles();
    const [loader, setLoader] = useState(true);
    const [toast, setToast] = useState({
        status: false,
        message: null,
        type: "success",
    });
    const [selectedValue, setSelectedValue] = useState({ local: '' });
    const [desiredOffset, setDesiredOffset] = useState(2);
    const [modeDetails, setModeDetails] = useState(null)

    const handleBack = () => {
        props.handleClick(PAGES.AIR_SYSTEM_SETTING);
    };
    useEffect(() => {
      props.siteId && getHVACDetails(true)
    }, [props.siteId])
  
  const getHVACDetails = async (showLoader) => {
    if (!props.siteId) return;
    if (showLoader) setLoader(true);

    try {
      const response = await HCServices.getHVACModeDetails(props.siteId)
      const devices = response?.data?.devices?.iqAir || [];
      console.log("devices getHVACModeDetails :: ",devices)
      const foundDevice = devices.find((device) => device.deviceId === props.airDeviceId);
      if (foundDevice) {
        setModeDetails(foundDevice);
        const selectedMode = foundDevice.energyMode === "SMART" ? "Smart Control" : "Manual Control";
        setSelectedValue({ local: selectedMode });
      }else{
        setSelectedValue({ local: "Manual Control"  });
      }
    } catch (error) {
      console.error('Error fetching Energy modes:', error);
    } finally {
      setLoader(false)
    }
  };
  const handleApply = () => {
    if(!props.hasAccess){
      setToast({status:true,message:getPermissionDeniedToastMessage(props.maskedOwnerEmail),type:'error'})
      return 
    }
  };
    const min = 1;
    const max = 5;
    const step = 1;
    const rangeMin = min;
    const marksArray = [1, 2, 3, 4, 5];
    const marks = marksArray;
    const ticks = marks.reduce((a, v) => ({ ...a, [v]: `${v}°F` }), {});
    function evSlider() {
      return  {
        className: '',
        value: Array.isArray(desiredOffset) ? desiredOffset : [desiredOffset],
        min,
        max,
        rangeMin,
        step,
        marks,
        ticks,
        onChange: (val) => {
          setDesiredOffset(Array.isArray(val) ? val[0] : val);
        },
        onClick: () => { },
        onAfterChange: (val) => {
          setDesiredOffset(Array.isArray(val) ? val[0] : val);
        },}
    };


    const GreenRadio = withStyles((theme) => ({
        root: {
            padding: "0px !important",
            color: `${theme.palette.tertiary.radioButtonColor} !important`,
            "&$checked": { color: `${theme.palette.tertiary.radioButtonCheckedColor} !important` },
            "&$disabled": { color: `${theme.palette.tertiary.radioButtonDisabledColor} !important` }
        },
        checked: {},
        disabled: {},
    }))((props) => <Radio color="default" className={classes.smallRadioButton} {...props} />);

    function controlTypeBox(controlType, subTitle, controlTypeSubHeading) {
      return (
        <Box className={classes.dFlex}>
          <Box className={classes.listCardRadio}>
            <GreenRadio
              disabled={loader}
              checked={selectedValue.local === controlType}
              onChange={(event) =>
                setSelectedValue((prev) => ({
                  ...prev,
                  local: event.target.value,
                }))
              }
              value={controlType}
              name="radio-button-group"
            />
            <Box className={classes.cardHeadingWithRadio}>
              <Typography className={classes.cardHeading}>
                {controlType}
              </Typography>
            </Box>
          </Box>
          <Box className={classes.modeHeaderContainer}>
            <Typography className={classes.description}>{subTitle}</Typography>
          </Box>
          {controlType === "Smart Control" && selectedValue.local === "Smart Control" && (
            <Box className={classes.sliderContainer}>
              <Box className={classes.dFlexSpaceBetween}>
                <Typography className={classes.sliderHeader}>
                  {controlTypeSubHeading}
                </Typography>
                <Typography className={classes.sliderBaseLine}>
                  {desiredOffset}°F ^
                </Typography>
              </Box>
              <Box className={classes.sliderWrapper}>
                <RangeSlider {...evSlider()} />
              </Box>
            </Box>
          )}
        </Box>
      );
    }  

    return (
    <>
      {!props.isWeb && <Header title="HVAC Energy Mode" onClick={handleBack} label={props.airDeviceName} />}
      <>
        {loader ? (<Box className={classes.loaderContainer}> <Icon src="loaderV4" width={"60px"} height={"60px"} /> </Box>) 
        : (<><Box className={classes.childModuleContainer}>
            <Box className={classes.toastPosition}>
              {toast.status && (
                <ToastMessage
                  shouldDisplay={toast.status}
                  content={toast.message}
                  handleClose={() =>
                    setToast({ status: false, message: null, type: null })
                  }
                  type={toast.type}
                  isWeb={props.isWeb}
                />
              )}
            </Box>
            <Box className={classes.componentContainer}>
              <Cards className={classes.learnMore} onClick={() => console.log("Learn more clicked")}>
                <Box className={classes.learnMoreBox}>
                  <Icon src={"Help"} className={classes.learnMoreIcon} />
                  <Typography className={classes.hyperLink}>
                    Learn more about HVAC Energy Modes
                  </Typography>
                </Box>
              </Cards>
            </Box>
            <Cards className={classes.card}>
              <CardContent>
                <Box className={classes.cardContainer}>
                  <Box className={classes.cardBody}>
                {controlTypeBox('Smart Control','Minimizes electricity bill','Desired temperature offset')}
                    <Divider className={classes.dividerBorderColor} />
               {controlTypeBox('Manual Control','HVAC follows the device settings','')}
                  </Box>
                </Box>
              </CardContent>
            </Cards>
            </Box>
            {/* As of now, No need to show the Apply button. Once the PUT call is defined, we will show the button. */}
            <Box className={classes.buttonContainer}>
              {/* <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                onClick={handleApply}
              >
                Apply
              </Button> */}
            </Box>
          </>)}
      </>
    </>
  );
};

export default HvacEnergyMode;